import React, { PropTypes, Component } from 'react';
import { LoadingIndicator } from 'common/components/preloader';
import DeleteModal from 'project/containers/entries/delete';
import ReinstateModal from 'project/containers/entries/reinstate_modal';
import RemoveCreativeModal from 'entries/containers/remove_creative_modal';
import Meta from 'project/containers/meta';


export default class SingleEntry extends Component {
  componentWillMount() {
    const { viewDisallowed, fetch, router, params } = this.props;
    if (viewDisallowed) {
      return router.push(`/${params.subcategory}/${params.projectUrl}/`);
    }
    return fetch();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.params.entryId !== this.props.params.entryId) {
      nextProps.fetch();
    }
  }

  render() {
    const { isLoading, entry, children } = this.props;
    if (isLoading || !entry || !entry.revisions[0]) {
      return <div>
      <Meta
        title="Entry"
        customMeta={[{ name: 'robots', content: 'noindex,nofollow' }]} />
        <LoadingIndicator />
      </div>;
    }

    return (<div>
      { children }

      <Meta
        title="Entry"
        customMeta={[{ name: 'robots', content: 'noindex,nofollow' }]} />
      <DeleteModal />
      <ReinstateModal />
      <RemoveCreativeModal />
    </div>);
  }
}

SingleEntry.propTypes = {
  entry: PropTypes.object,
  isLoading: PropTypes.bool,
  fetch: PropTypes.func.isRequired,
  router: PropTypes.object.isRequired,
  params: PropTypes.object.isRequired,
  viewDisallowed: PropTypes.bool.isRequired,
  children: PropTypes.any.isRequired,
  // closeUrl: PropTypes.any,
};



// WEBPACK FOOTER //
// ./single_entry/components/index.jsx